import styled from 'styled-components';

import { useStylesFor } from '@sine/sine-ui-components';

const PageContainer = styled.div`
  min-width: 350px;
  max-width: 100%;
  margin: 0 auto;

  ${() => useStylesFor('largeTablet').andSmaller`
    max-width: 430px;
    overflow: hidden;
  `};
`;

export default PageContainer;
